import { Injectable } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
    HttpResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { WksGedDocument } from '../models/wks-works.model';
import { EntityOCR } from '../../../models/common.model';
import { UserService } from '../../../services/user.service';
import { WksMistralOcrService } from '../services/wks-mistral-ocr.service';


@Injectable({
    providedIn: 'root'
})
export class WksGedDocumentService {

    private httpHeaders = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    constructor(
        private httpClient: HttpClient,
        private _userService: UserService,
        private _mistralOCRService: WksMistralOcrService
    ) {
    }

    /**
     * Récupération de tous les documents GED
     * d'une entité.
     */
    getDocuments(
        stdEntity: string
    ): Observable<WksGedDocument[]> {

        const url =
            `${environment.baseUrl}/wks/ged/documents`;

        let headers = this._userService.getHeaders();
        headers = headers.set(
                'stdEntity', this._userService.getUserLogged().entity,                
            );

        return this.httpClient.post<WksGedDocument[]>(
            url,
            null,
            {
                headers: headers
            }
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }


    /**
     * Récupération des documents GED
     * par statut de traitement.
     */
    getDocumentsByProcessingStatus(
    stdEntity: string,
    processingStatus: string,
    documentType?: string
        ): Observable<WksGedDocument[]> {

        const url =
            `${environment.baseUrl}/wks/ged/documents/status`;

        let headers = this._userService.getHeaders();
        headers = headers.set(
            'stdEntity',
            this._userService.getUserLogged().entity
        );

        const body: WksGedDocument = {
            processingStatus: processingStatus,
            documentType: documentType
        };

        return this.httpClient.post<WksGedDocument[]>(
            url,
            body,
            {
                headers: headers
            }
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }


    /**
     * Récupération d'un document GED.
     */
    getDocument(
        stdEntity: string,
        id: string
    ): Observable<WksGedDocument> {

        const url =
            `${environment.baseUrl}/wks/ged/document`;

        let headers = this._userService.getHeaders();
        headers = headers.set(
                'stdEntity', this._userService.getUserLogged().entity,                
            );

        const body: WksGedDocument = {
            id: id
        };

        return this.httpClient.post<WksGedDocument>(
            url,
            body,
            {
                headers: headers
            }
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }


    /**
     * Création d'un document GED.
     */
    createDocument(
        stdEntity: string,
        document: WksGedDocument
    ): Observable<WksGedDocument> {

        const url =
            `${environment.baseUrl}/wks/ged/document/create`;

        let headers = this._userService.getHeaders();
        headers = headers.set(
                'stdEntity', this._userService.getUserLogged().entity,                
            );

        return this.httpClient.post<WksGedDocument>(
            url,
            document,
            {
                headers: headers
            }
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }


    /**
     * Mise à jour d'un document GED.
     */
    updateDocument(
        stdEntity: string,
        document: WksGedDocument
    ): Observable<WksGedDocument> {

        const url =
            `${environment.baseUrl}/wks/ged/document/update`;

        let headers = this._userService.getHeaders();
        headers = headers.set(
                'stdEntity', this._userService.getUserLogged().entity,                
            );

        return this.httpClient.post<WksGedDocument>(
            url,
            document,
            {
                headers: headers
            }
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }

    cancelGedDocuments(
        documents: WksGedDocument[]
        ): Observable<any> {

        let headers = this._userService.getHeaders();
        headers = headers.set(
                'stdEntity', this._userService.getUserLogged().entity,                
            );


        return this.httpClient.post(
            `${environment.baseUrl}/wks/ged/documents/cancel`,
            documents,
            {
                headers: headers
            }
        );
    }

    /**
     * Désactivation logique d'un document GED.
     */
    disableDocument(
        stdEntity: string,
        id: string
    ): Observable<HttpResponse<any>> {

        const url =
            `${environment.baseUrl}/wks/ged/document/disable`;

        const headers =
            this.httpHeaders.set(
                'stdEntity',
                stdEntity
            );

        const body: WksGedDocument = {
            id: id
        };

        return this.httpClient.post(
            url,
            body,
            {
                headers: headers,
                observe: 'response'
            }
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }
    getDocumentContent(
        document: WksGedDocument
    ): Observable<Blob> {
        const url =
            `${environment.baseUrl}/wks/ged/document/content`;

       
        let headers = this._userService.getHeaders();
        headers = headers.set(
                'stdEntity', this._userService.getUserLogged().entity,                
            );

        return this.httpClient.post(
            url,
            document,
            {
                headers: headers,
                responseType: 'blob'
            }
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }
    getDocumentOcr(
        document: WksGedDocument
        ): Observable<string> {

        const url =
            `${environment.baseUrl}/wks/ged/document/ocr`;

        let headers = this._userService.getHeaders();

        headers = headers.set(
            'stdEntity',
            this._userService.getUserLogged().entity
        );

        return this.httpClient.post(
            url,
            document,
            {
                headers: headers,
                responseType: 'text'
            }
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }
    private handleErrorObservable(error: any): Observable<never> {
        throw error;
    }
}
